// extracted by mini-css-extract-plugin
module.exports = {"videoContainer":"BenefitsCMSPage_videoContainer__BjNUe","video":"BenefitsCMSPage_video__18H4g","helperHeaderContainer":"BenefitsCMSPage_helperHeaderContainer__2OTtc"};